
import {
    defineComponent,
    reactive,
    toRefs,
    onMounted,
    readonly,
    toRaw,
    onUnmounted
} from "vue";

import {
    apiRequest,
    apiSign,
    apiErrorCatch
} from "@/common/http";
import {
    User
} from "@/components/cigo-admin-core/utils/types";
import {
    CigoAdminStore
} from "@/components/cigo-admin-core/store";
import {
    TweenMax
} from "gsap";
import toArray from "lodash/toArray";
import {
    useForm
} from "@ant-design-vue/use";
import cigoLayer from "@/components/cigo-layer";
import router from "@/router";

export default defineComponent({
    name: "Login",
    setup(props) {
        let Env = reactive(process.env);
        const modelRef = reactive({
            username: "admin",
            password: "",
            module: "admin"
        });
        const rulesRef = reactive({
            username: [{
                required: true,
                message: "请输入用户名"
            }],
            password: [{
                required: true,
                message: "请输入密码"
            }]
        });
        const {
            resetFields,
            validate,
            validateInfos,
            mergeValidateInfo
        } = useForm(modelRef, rulesRef);

        onMounted(() => {
            TweenMax.to(".login-page-form", 1, {
                top: "30%",
                right: "10%",
                opacity: 1,
                delay: 0.8
            });
        });

        const doLogin = (e: any) => {
            e.preventDefault();
            validate()
                .then(() => {
                    let params = toRaw(modelRef);
                    apiRequest.v1
                        .post("/login", params, {
                            headers: apiSign(params)
                        })
                        .then(response => {
                            let userInfo: User = response.data.data;
                            userInfo.isLogin = true;
                            cigoLayer.msg("登录成功");
                            CigoAdminStore.saveUserInfo(userInfo);

                            router.push("/");
                        })
                        .catch(apiErrorCatch.v1);
                })
                .catch(err => {
                    console.log("error", err);
                });
        };

        return {
            Env,
            labelCol: {
                span: 6
            },
            wrapperCol: {
                span: 16
            },
            validateInfos,
            resetFields,
            doLogin,
            ...toRefs(modelRef)
        };
    }
});
